"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morro-reatino": {
    "3dbcf90b": [{
      "hkey": "b1eb55d4",
      "slug": "collatea-san-valentino",
      "name": "Collatea-San Valentino",
      "primary": true,
      "skipSearch": false
    }],
    "collatea": [{
      "hkey": "b1eb55d4",
      "slug": "collatea-san-valentino",
      "name": "Collatea-San Valentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "df528abf": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "skipSearch": false
    }],
    "la-croce": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5f075fe": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "skipSearch": false
    }],
    "le-casette": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55291b77": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "skipSearch": false
    }],
    "pacce": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e0ed8ee": [{
      "hkey": "b1eb55d4",
      "slug": "collatea-san-valentino",
      "name": "Collatea-San Valentino",
      "primary": true,
      "skipSearch": false
    }],
    "san-valentino": [{
      "hkey": "b1eb55d4",
      "slug": "collatea-san-valentino",
      "name": "Collatea-San Valentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "morro-reatino"
    }],
    "7c397a90": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "skipSearch": false
    }],
    "torricella": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "df1f85f1": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "skipSearch": false
    }],
    "valliola": [{
      "hkey": "1f176f42",
      "slug": "morro-reatino",
      "name": "Morro Reatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;